export default "\n<div class=\"box-modal_close arcticmodal-close\">x</div>\n\n<h3>{{title}}</h3>";